import {Button, Input, Modal, notification, Spin} from "antd";
import {useEffect, useState} from "react";
import {ApiService} from "../../services/ApiService";
import {APIs} from "../../constants/api.constants";
import {CloseOutlined} from "@ant-design/icons";


export default function EpisodeQuestionModal({ quizVisibility,
                                               quizEpisode,
                                               closeQuiz}) {

  const [loading, setLoading] = useState(false);
  const [choices, setChoices] = useState([]);
  const [correctChoice, setCorrectChoice] = useState(null);
  const [question, setQuestion] = useState('');
  const [loadingChoices, setChoiceLoading] = useState(true);
  const [isQuizConnected, setQuizConnected] = useState(false);
  const [copyQuiz, setCopyQuiz] = useState({});
  const [thumbnail, setThumbnail] = useState(null);

  useEffect( () => {
    quizVisibility && getQuizzes();
    setQuestion('');
    setChoices([]);
    setCorrectChoice(null);
    setThumbnail(null);
  }, [quizVisibility]);

  async function submit() {
    setLoading(true);
    const hasError = checkError();
    if (hasError) {
      setLoading(false);
      return;
    }
    let thumbnailURL = '';
    if (thumbnail) {
      thumbnailURL = await uploadNewThumbnail();
    }
    if (!isQuizConnected) {
      await createQuiz(thumbnailURL);
      return;
    }
    const editData = {
      id: copyQuiz.id,
      question: question,
      choice: choices,
      correct_choice: correctChoice,
      episode_number: copyQuiz.episode_number,
      thumbnail_image: thumbnailURL,
    }
    editQuiz(editData);
  }

  function uploadNewThumbnail() {
    return new Promise( (resolve, reject) => {
      const fd = new FormData();
      fd.append('file', thumbnail);
      ApiService.postRequest(APIs.media, fd).then(
          (res) => {
            resolve(res.data);
          },
          (err) => reject(err.message),
      )
    })
  }

  function handleClick() {
    document.getElementById('fileUpload').click();
  }

  function getQuizzes(){
    setChoiceLoading(true);
    if (!quizEpisode.course?.id) {
      setQuizRelated(null)
      notification['warn']({message: 'Related Course Has Been deleted, Cannot get old quiz' });
      return;
    }
    const param = `?filter=course.id||$eq||${quizEpisode.course?.id.toString()}\
                    &filter=episode_number||$eq||${quizEpisode.episode_number.toString()}`

    ApiService.getRequest(APIs.quiz + param ).then(
        (res) => {
          const quiz = res.data[0];
          setQuizRelated(quiz)
        },
        (error) => notification['error']({message: error.message }),
    )
  }

  function setQuizRelated(quiz) {
    setCopyQuiz(quiz || null);
    setQuestion(quiz?.question || '');
    setCorrectChoice(quiz?.correct_choice || null);
    setChoices(quiz?.choice || []);
    setQuizConnected(quiz?.choice.length > 0);
    setChoiceLoading(false);
  }

  function checkError() {
    if (!choices.length) {
      notification['error']({message: 'Please Add At Least One Choice' });
      return true;
    }
    if (!question || !correctChoice) {
      notification['error']({
        message: !question ? 'Please Enter the Question !' :  'Please Select the Correct Choice'
      });
      return true;
    }
    if (choices.some(item => item.choice_description === '')) {
      notification['error']({message: 'Choices Should Not Be Blank' });
      return true;
    }
    if(!quizEpisode.course?.id) {
      notification['error']({
        message: 'Please Connect The Episode and Course First'
      });
      return true;
    }
    return false;
  }

  function createQuiz(thumbnail) {
    const data = {
      "episode_number": quizEpisode.episode_number,
      "question": question,
      "correct_choice": correctChoice,
      "course": quizEpisode.course.id,
      "thumbnail_image": thumbnail,
    }
    return new Promise( (resolve, reject) => {
      ApiService.postRequest(APIs.quiz, data).then(
          (res) => {
            editQuiz(res.data);
            resolve();
          },
          (error) => {
            notification['error']({
              message: (error.message)
            });
            reject(error.message);
          },
      )
    })
  }

  function editQuiz(data) {
    if (!data) {
      notification['error']({ message : 'Data not Found'});
      return;
    }
    const id = Object.assign(data.id);
    delete data.id
    delete data.createDate
    delete data.updateDate
    delete data.deletedAt
    const patchData = { ...data, choice: choices};
    ApiService.updateRequest(APIs.quiz + '/' +  id, patchData).then(
        (res) => {
          closeQuiz();
          setLoading(false);
        },
        (error) => notification['error']({
          message: (error.message)
        }),
    )
  }

  function removeChoice(index) {
    setChoiceLoading(true);
    const filtered = choices.filter((item, filterItem) => filterItem !== index);
    !filtered.length && setCorrectChoice(null);
    setChoices(filtered);
    setTimeout(() => {
      setChoiceLoading(false);
    }, 1);
  }

  return <Modal visible={quizVisibility}
                title="Manage Quiz"
                onOk={submit}
                onCancel={closeQuiz}
                footer={[
                  <Button key="back"
                          onClick={closeQuiz}>
                    Return
                  </Button>,
                  <Button type="primary"
                          key="submit"
                          className={'btn btn-success'}
                          loading={loading}
                          onClick={submit}>
                    Submit
                  </Button>
                ]}>
            {!loadingChoices
                ? <div>
                  <div className={'row no-gutters'}>
                    <span className={'mb-2'}>Question</span>
                    <Input value={question}
                           className={'mb-3'}
                           onChange={
                             (e) => {
                               setQuestion(e.target.value);
                             }
                           }
                    />
                  </div>

                  <div className="row no-gutters justify-content-start">
                    <span className='mb-2'>Choices</span>
                    {
                      choices.map((choice, index) => {
                            return <div className={'d-flex mb-3 align-items-center'}
                                        key={index}>
                              <span className={'mx-3 clickable'}>
                                <input type="radio"
                                       readOnly={true}
                                       checked={ correctChoice === index + 1 }
                                       onClick={ () => setCorrectChoice(index + 1)}/>
                              </span>
                              <span className="mx-3"> {index + 1} </span>
                              <Input defaultValue={choice.choice_description}
                                     className={'mr-3'}
                                     key={index}
                                     onChange={
                                       (e) => {
                                         choices[index].choice_description = e.target.value;
                                         setChoices(choices);
                                       }
                                     }
                              />

                              <CloseOutlined className={'pointer'}
                                             onClick={() => {
                                                removeChoice(index);
                                             }}/>
                            </div>
                          }
                      )
                    }
                    <div>
                      <Button type='default'
                              onClick={() => {
                                const newList = [...choices, {choice_number: choices.length + 1, choice_description: ''}];
                                setChoices(newList);
                              }
                              }>
                        Add
                      </Button>
                    </div>
                  </div>

                  <div className='mt-3'>
                    <button onClick={handleClick}>
                      Choose File
                    </button>
                    <span className='ml-2'>{thumbnail?.name || 'No file chosen'}</span>
                    <input type="file"
                           id='fileUpload'
                           name='filename'
                           value=''
                           hidden
                           accept="image/png, image/gif, image/jpeg"
                           onChange={(e) => {
                             setThumbnail(e.target.files[0]);
                           }}/>
                  </div>
                </div>

                : <> <Spin className={'mr-2'} /> Loading ... </>
            }
        </Modal>
}
